import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ComponentsReport from "./ComponentsReport";

export default function Report() {
  return (
    <>
      <Sidebar activeItem="report" />
      <div className="content-wrapper">
        <TitleBar title="گزارش سایت ها" />

        <section className="content pt-5" id="report-content">
          <div className="container-fluid">
            <div className="row">
              <ComponentsReport />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
